import {
  accountantIcon,
  buildingIcon,
  EmployeesIcon,
  tasksIcon
} from "../../svg/svg";

export function MenuAll() {
  let menubar = {
    RMA_developer: [
      {
        title: "Building list",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_Building",
        children: [
          {
            title: "View All Buildings",
            to: "admin/buildinglist",
          },
        ],
      },
      {
        title: "Owner list",
        titleIcon: EmployeesIcon,
        name: "owner",
        targetId: "manege_owner",
        children: [
          {
            title: "View All Owner",
            to: "admin/ownerlist",
          },
        ],
      },
      {
        title: "Partner list",
        titleIcon: EmployeesIcon,
        name: "partner",
        targetId: "manage_partner",
        children: [
          {
            title: "View All Partner",
            to: "admin/partnerlist",
          },
        ],
      },
      {
        title: "Manager list",
        titleIcon: EmployeesIcon,
        name: "manager",
        targetId: "manege_manager",
        children: [
          {
            title: "View All Manager",
            to: "admin/managerlist",
          },
        ],
      },
      {
        title: "Accountant list",
        titleIcon: EmployeesIcon,
        name: "Accountant",
        targetId: "manege_accountant",
        children: [
          {
            title: "View All Accountant",
            to: "admin/accountantlist",
          },
        ],
      },
      {
        title: "Worker list",
        titleIcon: EmployeesIcon,
        name: "worker",
        targetId: "manege_worker",
        children: [
          {
            title: "View All Worker",
            to: "admin/workerlist",
          },
        ],
      },
      {
        title: "Tenant list",
        titleIcon: EmployeesIcon,
        name: "tanent",
        targetId: "manege_tenant",
        children: [
          {
            title: "View All Tenant",
            to: "admin/tenantlist",
          },
        ],
      },
      {
        title: "Miscellaneous",
        titleIcon: accountantIcon,
        name: "others",
        rentId: "others",
        children: [
          {
            title: "Taxation Information",
            to: "admin/taxation-information",
          },
        ],
      },
    ],
    Owner_sidebarList: [
      {
        title: "Manage Buildings",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_Building",
        children: [
          {
            title: "View All Buildings",
            to: "buildinglist",
          },
          {
            title: "Add Building",
            to: "addbuilding",
          },
        ],
      },
      {
        title: "Manage Partner",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_partner",
        children: [
          {
            title: "View All Partner",
            to: "partnerlist",
          },
          {
            title: "Add Partner",
            to: "addpartner",
          },
        ],
      },

      {
        title: "Manage Employees",
        titleIcon: EmployeesIcon,
        name: "employee",
        targetId: "manege_employee",
        children: [
          {
            title: "Manage Building Managers",
            to: "managerlist",
          },
          {
            title: "Add Managers",
            to: "addmanager",
          },
        ],
      },
      {
        title: "Manage Accountant",
        titleIcon: EmployeesIcon,
        name: "accountant",
        targetId: "manege_accountant",
        children: [
          {
            title: "View All Accountants",
            to: "accountantlist",
          },
          {
            title: "Add Accountant",
            to: "addaccountant",
          },
        ],
      },
      {
        title: "Manage Worker",
        titleIcon: EmployeesIcon,
        name: "worker",
        targetId: "manege_worker",
        children: [
          {
            title: "Manage Workers",
            to: "workerlist",
          },
          {
            title: "Add Worker",
            to: "addworker",
          },
        ],
      },
      {
        title: "Manage Request",
        titleIcon: accountantIcon,
        name: "request",
        targetId: "manege_request",
        children: [
          {
            title: "View All Request",
            to: "view-request",
          },
          // {
          //   title: "Pending Request",
          //   to: "notFound",
          // },
        ],
      },
      {
        title: "Manage Tasks",
        titleIcon: tasksIcon,
        name: "task",
        targetId: "manege_task",
        children: [
          {
            title: "View All Tasks",
            to: "tasklist",
          },
          {
            title: "Add Task",
            to: "addtask",
          },
        ],
      },

      {
        title: "Manage Tenant",
        titleIcon: accountantIcon,
        name: "tanent",
        targetId: "manage_tenant",
        children: [
          {
            title: "View All Tenant",
            to: "tenantlist",
          },
          {
            title: "Add Tenant",
            to: "addtenant",
          },
        ],
      },
      {
        title: "Collection Management",
        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Collection Management",
            to: "owner/rent/collection-management",
          },
        ],
      },
      {
        title: "Revenue and Expense Summary",

        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Revenue",
            to: "owner/revenue",
          },
          {
            title: "Expense Management",
            to: "comingpage",
          },
        ],
      },
      {
        title: "Miscellaneous",
        titleIcon: accountantIcon,
        name: "others",
        rentId: "others",
        children: [
          {
            title: "Cash Management",
            to: "owner/cash-management",
          },
          {
            title: "Banking Information",
            to: "owner/banking-information",
          },
          {
            title: "Taxation Information",
            to: "owner/taxation-information",
          },
        ],
      },
    ],
    Partner_sidebarList: [
      {
        title: "Manage Buildings",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_Building",
        children: [
          {
            title: "View All Buildings",
            to: "buildinglist",
          },
          {
            title: "Add Building",
            to: "addbuilding",
          },
        ],
      },

      {
        title: "Manage Employees",
        titleIcon: EmployeesIcon,
        name: "employee",
        targetId: "manege_employee",
        children: [
          {
            title: "Manage Building Managers",
            to: "managerlist",
          },
          {
            title: "Add Managers",
            to: "addmanager",
          },
        ],
      },

      {
        title: "Manage Worker",
        titleIcon: EmployeesIcon,
        name: "worker",
        targetId: "manege_worker",
        children: [
          {
            title: "Manage Workers",
            to: "workerlist",
          },
          {
            title: "Add Worker",
            to: "addworker",
          },
        ],
      },
      {
        title: "Manage Request",
        titleIcon: accountantIcon,
        name: "request",
        targetId: "manege_request",
        children: [
          {
            title: "View All Request",
            to: "view-request",
          },
          // {
          //   title: "Pending Request",
          //   to: "notFound",
          // },
        ],
      },
      {
        title: "Manage Tasks",
        titleIcon: tasksIcon,
        name: "task",
        targetId: "manege_task",
        children: [
          {
            title: "View All Tasks",
            to: "tasklist",
          },
          {
            title: "Add Task",
            to: "addtask",
          },
        ],
      },

      {
        title: "Manage Tenant",
        titleIcon: accountantIcon,
        name: "tanent",
        targetId: "manage_tenant",
        children: [
          {
            title: "View All Tenant",
            to: "tenantlist",
          },
          {
            title: "Add Tenant",
            to: "addtenant",
          },
        ],
      },
      {
        title: "Collection Management",
        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Collection Management",
            to: "partner/rent/collection-management",
          },
        ],
      },
      {
        title: "Revenue and Expense Summary",

        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Revenue",
            to: "owner/revenue",
          },
          {
            title: "Expense Management",
            to: "comingpage",
          },
        ],
      },
      {
        title: "Miscellaneous",
        titleIcon: accountantIcon,
        name: "others",
        rentId: "others",
        children: [
          {
            title: "Cash Management",
            to: "owner/cash-management",
          },
          {
            title: "Banking Information",
            to: "owner/banking-information",
          },
          {
            title: "Taxation Information",
            to: "partner/taxation-information",
          },
          // {
          //   title: "All Taxation",
          //   to: "owner/all-taxation",
          // },
        ],
      },
    ],

    Manager_sidebarList: [
      {
        title: "Manage Buildings",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_Building",
        children: [
          {
            title: "View All Buildings",
            to: "manager/buildinglist",
          },
        ],
      },
      {
        title: "Manage Worker",
        titleIcon: EmployeesIcon,
        name: "employee",
        targetId: "manege_worker",
        children: [
          {
            title: "Manage Workers",
            to: "manager/workerlist",
          },
          {
            title: "Add Worker",
            to: "manager/addworker",
          },
        ],
      },
      {
        title: "Manage Request",
        titleIcon: accountantIcon,
        name: "request",
        targetId: "manege_request",
        children: [
          {
            title: "View All Request",
            to: "manager/view-request",
          },
          // {
          //   title: "Add Request",
          //   to: "add-request",
          // }
          // ,
        ],
      },
      {
        title: "Manage Tasks",
        titleIcon: tasksIcon,
        name: "task",
        targetId: "manege_task",
        children: [
          {
            title: "View All Tasks",
            to: "manager/tasklist",
          },
          {
            title: "Add Task",
            to: "manager/addtask",
          },
        ],
      },

      {
        title: "Manage Tenant",
        titleIcon: accountantIcon,
        name: "tanent",
        targetId: "manage_tenant",
        children: [
          {
            title: "View All Tenant",
            to: "manager/tenantlist",
          },
          {
            title: "Add Tenant",
            to: "manager/addtenant",
          },
        ],
      },
      {
        title: "Rent Management ",
        titleIcon: accountantIcon,
        name: "tanent",
        targetId: "manage_tenant",
        children: [
          // {
          //   title: "View Rent by Building",
          //   to: "manager/rent-collection",
          // },
          {
            title: "Collection Management",
            to: "manager/rent/collection-management",
          },
        ],
      },
    ],
    Accountant_sidebarList: [
      {
        title: "Manage Buildings",
        titleIcon: buildingIcon,
        name: "building",
        targetId: "manege_Building",
        children: [
          {
            title: "View All Buildings",
            to: "accountant/buildinglist",
          },
        ],
      },
      {
        title: "Manage Worker",
        titleIcon: EmployeesIcon,
        name: "employee",
        targetId: "manege_worker",
        children: [
          {
            title: "Manage Workers",
            to: "accountant/workerlist",
          },
          {
            title: "Add Worker",
            to: "accountant/addworker",
          },
        ],
      },
      {
        title: "Manage Request",
        titleIcon: accountantIcon,
        name: "request",
        targetId: "manege_request",
        children: [
          {
            title: "View All Request",
            to: "accountant/view-request",
          },
          // {
          //   title: "Add Request",
          //   to: "add-request",
          // }
          // ,
        ],
      },
      {
        title: "Manage Tasks",
        titleIcon: tasksIcon,
        name: "task",
        targetId: "manege_task",
        children: [
          {
            title: "View All Tasks",
            to: "accountant/tasklist",
          },
          {
            title: "Add Task",
            to: "accountant/addtask",
          },
        ],
      },

      {
        title: "Manage Tenant",
        titleIcon: accountantIcon,
        name: "tanent",
        targetId: "manage_tenant",
        children: [
          {
            title: "View All Tenant",
            to: "accountant/tenantlist",
          },
          {
            title: "Add Tenant",
            to: "accountant/addtenant",
          },
        ],
      },
      {
        title: "Rent Management ",
        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Collection Management",
            to: "accountant/rent/collection-management",
          },
        ],
      },
      {
        title: "Revenue and Expense Summary",

        titleIcon: accountantIcon,
        name: "rent",
        rentId: "Rent_collectiont",
        children: [
          {
            title: "Revenue",
            to: "accountant/revenue",
          },
          {
            title: "Expense Management",
            to: "comingpage",
          },
        ],
      },
      {
        title: "Miscellaneous",
        titleIcon: accountantIcon,
        name: "others",
        rentId: "others",
        children: [
          {
            title: "Cash Management",
            to: "accountant/cash-management",
          },
          {
            title: "Banking Information",
            to: "accountant/banking-information",
          },
          {
            title: "Taxation Information",
            to: "accountant/taxation-information",
          },
          // {
          //   title: "All Taxation",
          //   to: "accountant/all-taxation",
          // },
        ],
      },
    ],
  };

  return menubar;
}
